var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.754,
    height: 14.368,
    viewBox: "0 0 20.754 14.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    transform: "translate(-3.375 -7.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M23.96,10.344l-5.368,5.468a.1.1,0,0,0,0,.14l3.757,4a.647.647,0,0,1,0,.918.65.65,0,0,1-.918,0l-3.742-3.986a.1.1,0,0,0-.145,0l-.913.928a4.017,4.017,0,0,1-2.864,1.207,4.1,4.1,0,0,1-2.924-1.242l-.878-.893a.1.1,0,0,0-.145,0L6.079,20.871a.65.65,0,0,1-.918,0,.647.647,0,0,1,0-.918l3.757-4a.106.106,0,0,0,0-.14L3.545,10.344a.1.1,0,0,0-.17.07V21.355a1.6,1.6,0,0,0,1.6,1.6H22.533a1.6,1.6,0,0,0,1.6-1.6V10.414A.1.1,0,0,0,23.96,10.344Z",
    transform: "translate(0 -0.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M14,17.01a2.712,2.712,0,0,0,1.951-.818l7.828-7.967a1.568,1.568,0,0,0-.988-.349H5.214a1.558,1.558,0,0,0-.988.349l7.828,7.967A2.713,2.713,0,0,0,14,17.01Z",
    transform: "translate(-0.247)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ffc0acc084d987edf6fff7d25933a1e2.svg";
export { ForwardRef as ReactComponent };